/*
 *
 * Selectors for RestaurantsList
 *
 */

import { createSelector } from 'reselect';
const selectRestaurantsListDomain = (state) => state.get('restaurantsListPage');

/**
 * @todo: if selectors increases can be merged in one selector
 * @todo: add the default condition of all
 */
const isLoading = () => createSelector(
  selectRestaurantsListDomain,
  (RestaurantsList) => RestaurantsList.get('isLoading'));

const selectRestaurantsList = () => createSelector(
  selectRestaurantsListDomain,
  (RestaurantsList) => RestaurantsList.get('restaurantList').toJS(),
);

const selectRestaurantsLocation = () => createSelector(
  selectRestaurantsListDomain,
  (RestaurantsList) => RestaurantsList.get('restaurantLocations').toJS(),
);

const selectRestaurantsCuisines = () => createSelector(
  selectRestaurantsListDomain,
  (RestaurantsList) => RestaurantsList.get('restaurantCuisines').toJS());

const selectRestaurantsCollections = () => createSelector(
  selectRestaurantsListDomain,
  (RestaurantsList) => RestaurantsList.get('restaurantCollection').toJS());

const selectRestaurantsDeal = () => createSelector(
  selectRestaurantsListDomain,
  (RestaurantsList) => RestaurantsList.get('restaurantDeal').toJS());

export {
  isLoading, selectRestaurantsList, selectRestaurantsLocation,
  selectRestaurantsCuisines, selectRestaurantsCollections, selectRestaurantsDeal,
};



// WEBPACK FOOTER //
// client/containers/RestaurantsList/selectors.js